import { selectIsByHomeowner, selectIsNewOffer, selectOfferCategory } from '../../../../../shared/selectors/offer';
import { selectUserId } from '../../../../../shared/selectors/user';
import app from '../../../scripts/app';

app.service('activeDraftService', [
  'apiService',
  'adStateService',
  'addFormService',
  'userService',
  '$interval',
  '$log',
  'store',
  function (apiService, adStateService, addFormService, userService, $interval, $log, store) {
    const modeEnums = Object.freeze({
      REMOTE: 1,
      LOCAL: 2,
    });
    const autoSaveInterval = 10000;
    const successRequest = {
      config: {},
      data: {
        status: 'ok',
        data: null,
      },
      status: 200,
      statusText: 'OK',
    };

    let lastSavedDraft;
    let autoSavePromise;
    let localDraftEnabled = false;
    let draftMode = null;

    this.modeEnums = modeEnums;

    const saveDraft = () => {
      this.saveDraft(addFormService.ad, addFormService.form);
    };

    const isRemoteModeForced = () => {
      return window.location.search.includes('remoteAd=1');
    };

    this.getDraftMode = () => {
      if (isRemoteModeForced()) {
        return modeEnums.REMOTE;
      }
      const isByCommercialOwner = addFormService.ad && addFormService.ad.isByCommercialOwner;

      return draftMode || (isByCommercialOwner ? modeEnums.LOCAL : modeEnums.REMOTE);
    };

    this.setDraftMode = mode => {
      if (mode !== 'auto' && Object.keys(modeEnums).every(name => mode !== modeEnums[name])) {
        return;
      }

      draftMode = mode;
    };

    this.saveDraft = (adv, form, skipCompare = false) => {
      const state = store.getState();
      const isNewOffer = selectIsNewOffer(state);

      if (!isNewOffer) {
        return;
      }

      const userId = selectUserId(state);
      const offerCategory = selectOfferCategory(state);
      const isByHomeowner = selectIsByHomeowner(state);

      const mode = this.getDraftMode(); // тип modeEnums
      const isByCommercialOwner = adv.isByCommercialOwner;

      adv.phones = adStateService.handlePhones(adv.phones, form);

      const offer = adStateService.cleanAdModel(adv, true);

      const offerWithoutFiles = angular.copy(offer);

      if (offerWithoutFiles.photos && offerWithoutFiles.photos.length) {
        offerWithoutFiles.photos = offerWithoutFiles.photos.length;
      }

      if (
        offer &&
        offerCategory &&
        (skipCompare || !angular.equals(JSON.stringify(offerWithoutFiles), lastSavedDraft))
      ) {
        /*
          isByHomeowner удаляется в методе cleanAdModel по флагу !userCanPublishAdAsHomeownerInCurrentCategory.
          Поскольку userCanPublishAdAsHomeownerInCurrentCategory всегда возвращает false для неавторизированных пользователей,
          сохраняем isByHomeowner вручную для работы с локальным черновиком.
          Также userId для сравнения, восстаноавливать ли черновик для конкретного пользователя
        */
        const draftData = {
          ...offer,
          isByHomeowner,
          isByCommercialOwner,
          userId,
        };

        if (mode === modeEnums.LOCAL) {
          try {
            localStorage.setItem('savedDraft', JSON.stringify(draftData));
            lastSavedDraft = JSON.stringify(offerWithoutFiles);

            return;
          } catch (err) {
            // Если при сохр произошел exception, переключаемся на remote
            localStorage.removeItem('savedDraft');
            this.setDraftMode(modeEnums.REMOTE);
          }
        }
        if (userService.isAuthenticated) {
          apiService
            .postDraft(offer)
            .then(() => {
              lastSavedDraft = JSON.stringify(offerWithoutFiles);
            })
            .catch(err => {
              $log.error('Ошибка localStorage: ', err);
            });
        }
      }
    };

    this.getDraftGuid = () => {
      if (lastSavedDraft) {
        const parsedDraft = JSON.parse(lastSavedDraft);

        return parsedDraft.objectGuid;
      }

      return undefined;
    };

    this.deleteDraft = guid => {
      lastSavedDraft = undefined;
      const mode = this.getDraftMode(); // тип modeEnums

      if (mode === modeEnums.LOCAL) {
        return Promise.resolve().then(() => {
          localStorage.removeItem('savedDraft');

          return successRequest;
        });
      }

      return apiService.deleteDraft(guid);
    };

    this.isActiveDraftEnabled = () => {
      if (isRemoteModeForced()) {
        return Promise.resolve(true);
      }

      const mode = this.getDraftMode();

      if (mode === modeEnums.LOCAL) {
        return Promise.resolve(localDraftEnabled);
      }

      return apiService.getDraftSettings().then(settings => settings && settings.data && settings.data.isDraftEnabled);
    };

    this.enableActiveDraft = (isActiveDraftMustEnabled = true) => {
      const mode = this.getDraftMode();

      if (mode === modeEnums.LOCAL) {
        return Promise.resolve().then(() => {
          localDraftEnabled = isActiveDraftMustEnabled;

          return successRequest;
        });
      }

      return apiService.postDraftSettings({
        isDraftEnabled: isActiveDraftMustEnabled,
      });
    };

    this.getActiveDraft = guid => {
      const mode = this.getDraftMode();
      const params = {
        objectGuid: guid,
      };

      if (mode === modeEnums.LOCAL) {
        return Promise.resolve().then(() => {
          return {
            data: JSON.parse(localStorage.getItem('savedDraft')),
            status: 'ok',
          };
        });
      }

      return apiService.getDraft(params).then(response => response.data);
    };

    // Автосохранение в localStorage, если пользователь не авторизован(только для собственников)
    this.setLocalAutoSave = (isAutosaveMustEnabled = true) => {
      if (isRemoteModeForced()) {
        return;
      }

      $interval.cancel(autoSavePromise);

      if (isAutosaveMustEnabled) {
        this.setDraftMode(modeEnums.LOCAL);
        this.enableActiveDraft(true);
        // Сохраняем сразу, т.к. в кейсе, если польз. заполнил форму как собственник, переключился на агента и решил,
        // что он снова собственник и закроет страницу, черновик не сохранится и при загрузке страницы будет пустая форма
        saveDraft();
        autoSavePromise = $interval(saveDraft, autoSaveInterval);
      } else {
        this.setDraftMode(modeEnums.LOCAL); // Отключаем состояние activeDraft только для локального сохранения
        this.enableActiveDraft(false);
        this.deleteDraft(addFormService.ad.objectGuid);
        this.setDraftMode('auto');
      }
    };
  },
]);
